export default "__VITE_ASSET__wBZaq5hW__"